import React,{ useEffect } from "react";
import { useState } from "react";
import Table from "../../components/admin/Table";
import { userList, resetApiStatus} from "../../slices/UserSlice";
import { allActiveRoles } from "../../slices/PermissionsSlice";
import { useDispatch } from "react-redux";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import { CamelToSentanceCase } from "../../Utils/utils/CommanFnc";
// import * as Yup from "yup";
import { Link, useSearchParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
//import { MessageAlert } from "../../components/admin/MessageAlert";
import SelectBox from "../../components/admin/SelectBox";

export function List() {
  const [columsData, setColumsData] = useState([]);
  const [businessData, setBusinessData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams()
  const queryString = Object.fromEntries([...searchParams.entries()])
  const data = useSelector((state) => state.users)
  const loading = useSelector( (state) => state.users.loading )
  const roleData = useSelector((state)=> state.permissions.roleList)
  // const vErrors = useSelector( (state) => state.users.errors ) 
  // const success = useSelector( (state) => state.users.success )
 //  const [modelData, setModelData] = useState({})
 const defaultSetting = {
    pageLength:queryString.pageLength?queryString.pageLength:defaultConfig.defaultLimit,
    page:queryString.page?queryString.page:1,
    userType: 'staff'
  }
  const [defaultParams, setDefaultParams] = useState(defaultSetting)
  const [serachString, setSearchString] = useState({
    searchString:queryString.searchString?queryString.searchString:''
  })
  const [roleList, setRoleList] = useState([])
  // const [modelContent, setModelContent] = useState("")
  const dispatch = useDispatch()  
  const columns =  useMemo(()=>{
    let cols =  [
      {
        id:" empCode",
        name:"Emp Code",
        selector: (row) => row?.empCode,
        sortable: true,
        center: true,
      },
      {
        id: "name",
        name:"Name",
        selector: (row) => row.name,
        sortable: true,
        center: true,
      },
      {
        id: 'phone',
        name: "Mobile No.",
        selector: (row) => row.phone,
        sortable: true,
        center: true,
      },
      {
        id: 'email',
        name: "Email",
        compact:true,
        wrap: true,
        selector: (row) => row.email,
        sortable: true,
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
      },
      {
        name: "gender",
        compact:true,
        selector: (row) => CamelToSentanceCase(row.gender),
        sortable: false,
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
      },
      {
        name: "Role",
        selector: (row) => row.role.label,
        sortable: false,
        center: true,
      },
      {
        name:"Status",
        selector: (row) => row.status,
        sortable:false,
        center:true,
        cell: (row) => (
          <>
            <i className={`far fa-dot-circle fa-w-16 ${row.status === 'active'?'text-success':'text-muted'}`} aria-hidden="true"></i>
            &nbsp;
            {CamelToSentanceCase(row.status) || 'Inactive'}
          </>
        )
      },
      {
        name: "Action",
        button:false,
        selector: "action",
        center: true,
        cell: (row) => (
          <Link to={`/edit-user/${row._id}`}  className="sidebar-link" data-toggle="tab">
            {" "}
            <i className="fa fa-edit"></i>{" "}
          </Link>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
      },
    ];
    
    console.log(cols)
    return cols
  },[])
  // const formSchema = Yup.object().shape({
  //   coin: Yup.number()
  //    .typeError("Please enter valid number")
  //    .min(1, "Minimum value should be 1."),
  // });

  useEffect(()=>{
    if(Object.keys(queryString).length === 0){
      dispatch(userList({data: {...defaultParams}}))
    }else{
      setDefaultParams({...defaultParams, ...queryString}) 
    }
    dispatch(allActiveRoles())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch]);

  useEffect( () =>{
    setColumsData(columns)
  },[columns, defaultParams])

  useEffect( ()=>{
    setBusinessData(data)
  },[data])

  useEffect( ()=>{ 
    let roleList = roleData?.map( (item) => {
          return {
              value:item._id,
              label:item.label
          }
    } )

    if(roleList){
      setRoleList(roleList)
    }
  }, [roleData])

  const setFormValue = (event) => {
    setSearchString({searchString: event.target.value})
  }

  const searchInt = () => {
    let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
    setSearchParams(params)  
    setDefaultParams(params)
    dispatch(userList({data: {...params}}))
  }

  const resetSearch = () =>{
    setDefaultParams(defaultSetting)
    setSearchParams(defaultSetting)
    dispatch(resetApiStatus())
    dispatch(userList({data: {...defaultSetting}}))
  }

  const onSelectChange = (opt, name) => {
    let searchQuery = {...serachString}
    switch(name) {
      case 'role':
        searchQuery = {...serachString, role: opt?.value || ''}
        
      break;
      case 'status':
        searchQuery = {...serachString, status: opt?.value || ''}
      break;
      default:
    }
    setSearchString(searchQuery)
    setSearchParams(searchQuery)
    //setBusinessData([]);
    
  }

  const setPaginationData = (paginationData) =>{
    const params = {...defaultParams, page:paginationData.page, pageLength:paginationData.pageLength}
    setDefaultParams(params)
    setSearchParams(params)
  }
    
  return (
    <React.Fragment>
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-users"></i> Users</h4>
              </div>
              <div className="row m-3">
                  <div className="col-sm-8">
                    <div className="row">
                      <div className="col-sm-3 col-10 p-0">
                          <input
                          type="text"
                          defaultValue={serachString.searchString}
                          onChange={setFormValue}
                          placeholder="Search..."
                          className="form-control"
                          />
                      </div>
                      &nbsp;
                      <div className="col-sm-3 p-0">
                          <SelectBox
                              placeholder="Select Role"
                              options={roleList}
                              isClearable={true}
                              defaultValue={''}
                              value={roleList.filter( (item) => item.value === serachString.role) }
                              onChange={(opt) => onSelectChange(opt, 'role')}
                              
                          />
                      </div>
                      &nbsp;
                      <div className="col-sm-3 p-0">
                          <SelectBox
                              placeholder="Select Status"
                              options={defaultConfig.status}
                              isClearable={true}
                              defaultValue={''}
                              value={defaultConfig.status?.filter( (item) => item.value === serachString.status) }
                              onChange={(opt) => onSelectChange(opt, 'status')}
                              
                          />
                    </div>
                      <div className="col-sm-2 col-1 p-0 ml-1">
                        <button onClick={searchInt} type="button" className="btn btn-primary btn-lg">
                          <i className="fa fa-search"></i>
                        </button>
                        &nbsp;
                      <button onClick={resetSearch} type="button" className="btn btn-primary btn-lg">
                        <i className="fa fa-undo"></i>
                      </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 p-0 text-right">
                    <Link
                        to={{
                          pathname: `/user-add`,
                          search: "",
                          hash: "",
                        }} replace 
                        state={defaultParams}
                        className="button blue-button btn-success"
                        data-toggle="tab"
                      >
                        <i className=" fa fa-plus" />
                        {" "}
                        Add User
                      </Link>
                  </div>
                </div>
              <Table 
                totalCount={businessData.totalCount}
                data={businessData.list} 
                columns={columsData} 
                dataLoadFnc={userList} 
                extraConfig = {defaultParams} 
                loading={loading} 
                callBack={setPaginationData}
              />
            </div>
          </div>
        </div>
      </div>
      {loading === true?<Loading/>:"" }
      
    </React.Fragment>
  );
}
